/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       ListColorImage.tsx
 * @author     Christian Ascone
 * @date       9/20/19 3:24 PM
 */

import React from 'react';
import {Image} from "react-native";

export function ListColorImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/list_color.png')
            }
        />
    );
}